// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"web_src_layouts_BaseLayout_tsx":"6471b09747a689a0acc8","web_src_pages_home_index_tsx-web_src_assets_imgs_1_png-web_src_assets_imgs_2_png-web_src_asse-82847b":"50bc5e3a1b02bb733537"}[chunkId] + ".css";
};